<template>
  <div>
    <vx-card v-if="showMatches" class="mb-10">
      <div class="relative">
        <div>
          <vs-button @click="goBack" color="primary" type="filled"
            >Back</vs-button
          >
          <input
            type="checkbox"
            v-model="allSelected"
            style="float:right;"
            @click="selectAll"
          />

          <template class="ml-10">

            
            <vs-button
              type="filled"
              style="float:right; margin-right: 50px;"
              @click="acceptSelected"
              >Proceed</vs-button
            >
          </template>

          <!-- <vs-button
            color="primary"
            type="filled"
            style="float:right;margin-right: 20px;"
            @click="finishedSelected"
            >Finished</vs-button
          > -->
        </div>
      </div>
    </vx-card>
    <vx-card v-if="!showMachineLearning">
      <div class="text-center p-5">
        <h4>{{ 'Total : ' +  match_contacts.length }} </h4> 

      </div>

      <template v-for="(matched_contact, key) in match_contacts">
        <vs-table stripe :data="matched_contact" class="mb-20">
          <template slot="header">
            <h3 class="pb-5">Match {{ key + 1 }}</h3>
            <h3 class="pb-5">
              Confidence

              {{ parseFloat(matched_contact.slave.score).toFixed(2) }} {{ "%" }}
            </h3>


            <input
              type="checkbox"
              v-model="selected"
              @click="select"
              :value="{
                uuid: matched_contact.contact_id,
                slave_id: matched_contact.slave.ml_id,
                account_id: matched_contact.slave.account_id

              }"
            />
            <!-- <vs-checkbox
              v-model="selected"
              :vs-value="{'uuid':matched_contact.id,'slave_id':matched_contact.slave.ml_id}"
            ></vs-checkbox> -->
          </template>

          <template slot="thead">
            <vs-th v-if="matched_contact.slave.ml_company">Company</vs-th>
            <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th
              >
            <vs-th v-if="matched_contact.slave.ml_forename">Forename</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_surname">Surname</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_job_title">Job Title</vs-th
                >
                <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th
                  >
                  <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th
                    >
                    <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th
                      >
                      <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th
                        >
                        <vs-th v-if="matched_contact.slave.ml_seniority">Seniority</vs-th
                          >
                          <vs-th v-if="matched_contact.slave.ml_role">Role</vs-th
                            >
                            <vs-th v-if="matched_contact.slave.ml_sub_role">Sub Role</vs-th
                              >
                     
         
          
          </template>

          <template slot-scope="{ data }">
            <vs-tr>
            
              <vs-td v-if="matched_contact.slave.ml_company">
                {{ matched_contact.company_name }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.contact_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.contact_forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.contact_surname }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_job_title">
                {{ matched_contact.contact_job_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_email">
                {{ matched_contact.contact_email }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_mobile">
                {{ matched_contact.contact_mobile }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_ddi">
                {{ matched_contact.contact_ddi }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_social_media">
                {{ matched_contact.contact_social_media }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_seniority">
                {{ matched_contact.contact_seniority }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_role">
                {{ matched_contact.contact_role }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_sub_role">
                {{ matched_contact.contact_sub_role }}
              </vs-td>
            
            </vs-tr>



            <vs-tr>
              <vs-th v-if="matched_contact.slave.ml_company">Company</vs-th>
              <vs-th v-if="matched_contact.slave.ml_title">Title</vs-th
                >
              <vs-th v-if="matched_contact.slave.ml_forename"
                >Forename</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_surname"
              >Surname</vs-th
            >
            <vs-th v-if="matched_contact.slave.ml_job_title">Job Title</vs-th
              >
              <vs-th v-if="matched_contact.slave.ml_email">Email</vs-th
                >
                <vs-th v-if="matched_contact.slave.ml_mobile">Mobile</vs-th
                  >
                  <vs-th v-if="matched_contact.slave.ml_ddi">DDI</vs-th
                    >
                    <vs-th v-if="matched_contact.slave.ml_social_media">Social Media</vs-th
                      >
                      <vs-th v-if="matched_contact.slave.ml_seniority">Seniority</vs-th
                        >
                        <vs-th v-if="matched_contact.slave.ml_role">Role</vs-th
                          >
                          <vs-th v-if="matched_contact.slave.ml_sub_role">Sub Role</vs-th
                            >
            </vs-tr>



            <vs-tr>
              <vs-td v-if="matched_contact.slave.ml_company">
                {{ matched_contact.slave.ml_company }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_title">
                {{ matched_contact.slave.ml_title }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_forename">
                {{ matched_contact.slave.ml_forename }}
              </vs-td>
              <vs-td v-if="matched_contact.slave.ml_surname">
                {{ matched_contact.slave.ml_surname }}
              </vs-td>
            <vs-td v-if="matched_contact.slave.ml_job_title">
            {{ matched_contact.slave.ml_job_title }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_email">
            {{ matched_contact.slave.ml_email }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_mobile">
            {{ matched_contact.slave.ml_mobile }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_ddi">
            {{ matched_contact.slave.ml_ddi }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_social_media">
            {{ matched_contact.slave.ml_social_media }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_seniority">
            {{ matched_contact.slave.ml_seniority }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_role">
            {{ matched_contact.slave.ml_role }}
            </vs-td>
            <vs-td v-if="matched_contact.slave.ml_sub_role">
            {{ matched_contact.slave.ml_sub_role }}
            </vs-td>
              <vs-td> </vs-td>
              <vs-td> </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </vx-card>
    <vx-card v-if="showMachineLearning"
      title="Now You Need To Match Contact Fields For Machine Learning"
      class="mt-2"
    >
    <div class="vx-row">


    <div class="vx-col sm:w-1/2 w-full">
      <vs-icon @click="active1=!active1" style="float: right;"  size="small"  icon="info"></vs-icon>

      <p>
        On the left are the fields from our database. On the right are the
        fields from the file you have uploaded.
        <br> Please choose at least two
        columns to get the perfect result

      </p>
      
      
    </div>
    <div class="vx-col sm:w-1/2 w-full">

      <vs-alert style="background:none; color:#626262;"
:active.sync="active1"
closable
close-icon="cancel">
<h6>Note :</h6>
<p>
  * Fields should be matched correctly to get the best result
</p>

</vs-alert>

     
    </div>
    </div>


    

      <!-- <vs-progress  color="primary"></vs-progress>
      <p class="text-center mt-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
      <div class="vx-row p-10">
        <div class="vx-col w-full md:w-1/2">
          <vs-list>
            <vs-list-header
              title="Database Fields"
              color="primary"
            ></vs-list-header>

            
            <div v-for="(slot, index) in fieldgroups" :key="index">
              <div class="vx-row">
                <div class="vx-col w-full md:w-4/5">
                  <v-select
                    @input="setSelected"
                    class="pb-3 pt-3"
                    :options="list1"
                    v-model="slot.dbfield"
                  />
                </div>
                <div class="vx-col w-full md:w-1/5">
                  
                  <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon>

                  
                  <!-- <vs-icon size="18px" 
                  class="cursor-pointer mt-3"
                  @click="deleteColumn(slot)"
                  color="danger"
                  icon="delete"
                  :key="index + 1"
                ></vs-icon> -->
                </div>
              </div>
            </div>
            <p class="mb-3" v-if="list1.length == 8">
              {{ validation_message }}
            </p>
          </vs-list>
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            @click="addAnother"
            >Add another column</vs-button
          >
        </div>
        <div class="vx-col w-full md:w-1/2">
          <vs-list>
            <vs-list-header
              title="Uploaded Fields"
              color="primary"
            ></vs-list-header>
            <div v-for="(slot, index1) in fieldgroups" :key="index1">
                <v-select
                multiple
                :closeOnSelect="false"
                class="pb-3 pt-3"
                :options="csv_table_fields"
                v-model="slot.uploadfield"
              />

             
            </div>
          </vs-list>
        </div>
        <div class="vx-col w-full">
          <div class="">
            <vs-button
              @click="matchField()"
              color="primary"
              type="filled"
              style="float:right;"
              >Match Field</vs-button
            >
          </div>
        </div>
      </div>
    </vx-card>
    <progress-bar v-if="showMachineLearning" bar-color="grey" :val="uploadPercentage" :text="PLeasewait"></progress-bar>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import ImportExcel from "@/components/excel/ImportExcel.vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
import ProgressBar from 'vue-simple-progress'
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    draggable,
    Prism,
    vSelect,
    ProgressBar

  },
  data() {
    return {
      PLeasewait: '',
      uploadPercentage: 0,
      active1:false,
      selected_campaign: {},
      showMachineLearning:true,
      abilities : null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      match_ten_context: [],
      validation_message: "",
      total_pages: 0,
      limit: 10,
      currentx: 1,
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      showMatches: false,
      match_contacts: [],
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      csv_table_fields: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      list1: [
        {
          name: "company_name",
          value: "company_name",
          label: "Company Name",
          selection: true
        },
        {
          name: "title",
          value: "title",
          label: "Title",
          selection: true
        },
        {
          name: "forename",
          value: "forename",
          label: "Forename",
          selection: true
        },
        {
          name: "surname",
          value: "surname",
          label: "Surname",
          selection: true
        },
        {
          name: "job_title",
          value: "job_title",
          selection: true,
          label: "Job Title"
        },
        {
          name: "email",
          value: "email",
          selection: true,
          label: "Email"
        },
        {
          name: "ddi",
          value: "ddi",
          selection: true,
          label: "DDI"
        },
        {
          name: "mobile",
          value: "mobile",
          selection: true,
          label: "Mobile"
        },
        {
          name: "social_media",
          value: "social_media",
          selection: true,
          label: "Social Media"
        },
        {
          name: "role",
          value: "role",
          selection: true,
          label: "Role"
        },
        {
          name: "sub_role",
          value: "sub_role",
          selection: true,
          label: "Sub Role"
        },
        {
          name: "seniority",
          value: "seniority",
          selection: true,
          label: "Seniority"
        }
      ]
    };
  },
  mounted() {
    this.getColumnsFromCSVTable()
  },
  watch: {
 
  },
  methods: {
    acceptSelected() {
      this.$vs.loading();
      let self = this;
      let selected_data = {};
      selected_data.selected = this.selected;
      selected_data.table_name = this.table_name;
      selected_data.campaign_id = this.$route.params.campaignId;
      axios
        .post(
          this.$base_url + "/api/contacts/save_matched_contact",
          selected_data
        )
        .then(response => {
          if (response.data.status == "success") {

            self.$router.replace("/contacts/unmatched/" + self.$route.params.campaignId);
            self.$vs.loading.close();
          }else{


            let notUpdatedData = response.data.data


            this.$vs.dialog({
              color: "primary",
              title: `Import Contact To Campaign`,
              text: " You accepted " + notUpdatedData.no_of_accepted + " machine learning matched contacts, however only " + notUpdatedData.no_of_updated + " were imported to the campaign.  Please contact support to get this issue rectified before proceeding with the contact import process.  Do not close this window. The following matched contacts were not successfully added to the campaign: ",
              accept: this.acceptAlert
            });

             console.log("Not updated" , response.data.data)

            self.$vs.loading.close();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    acceptAlert() {
      return
    },
    getColumnsFromCSVTable(){
      let self = this
      let data = {};
      data.campaign_id = this.$route.params.campaignId
      data.level = 'contacts'
      // alert(this.table_name)
      axios
        .post(
          this.$base_url + "/api/contacts/get_columns_from_table",
          data
        )
        .then(response => {
            let result = JSON.parse(response.data.selected_field)


            console.log("Columns" , result)


            result.forEach(function(ele){
              self.csv_table_fields.push({
                id: ele.id,
                label :  ele.name,
                name: ele.name
            })
        })
        }).catch(error => {
            console.log(error);
          });
    },
    validatetUserUploaded() {
      let data = {};
      data.table_name = 'temp_' + this.selected_campaign["id"].replaceAll("-", "_") + '_contacts';
      axios
        .post(
          this.$base_url + "/api/contacts/get_user_uploaded_table_name",
          data
        )
        .then(response => {
          if (response.data === undefined || response.data.length == 0) {
            this.table_name_exists = null;
            if (this.upload_validation == true) {
              this.upload_validation_message = null;
              this.showImportWidget = false;
              this.$vs.loading.close();
            } else {
              this.upload_validation_message = "Please upload a file";
            }
          } else {
            this.table_name_exists =
              "File name already exists. Please try another";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    finishedSelected() {
      let self = this


    },
    setSelected(field) {
      // this.list1 = this.list1.filter(function(el) {
      //   return el.name != field.name;
      // });
    },
    ucFirstAllWords(str) {
      var pieces = str.split(" ");
      for (var i = 0; i < pieces.length; i++) {
        var j = pieces[i].charAt(0).toUpperCase();
        pieces[i] = j + pieces[i].substr(1);
      }
      return pieces.join(" ");
    },
    formatUploadedHeader(s) {
      if (typeof s !== "string") return "";
      s = s.replace("_", " ");
      s = s.replace("_", " ");
      s = s.replace("slave", " ");
      s = s.replace("master", " ");
      s = s.replace("_", " ");
      s = s.replace("ml", " ");
      s = s.replace("_", " ");
      return this.ucFirstAllWords(s);
    },
    goBack: function() {
      this.showMatches = false;
            this.showMachineLearning = false;

      
    },
    addAnother: function() {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: [],
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function(ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validatetUserUploaded();
        }
      });
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    selectAll() {

    


      // this.$vs.loading();




      let matches = this.match_contacts;

      if (this.allSelected) {
        matches.forEach(match => {
          this.selected.pop({ uuid: match.contact_id, slave_id: match.slave.ml_id,account_id: match.slave.account_id });
        });
      } else {

        matches.forEach(match => {
          this.selected.push({ uuid: match.contact_id, slave_id: match.slave.ml_id,account_id: match.slave.account_id });
        });
   
      }


      console.log("Selected" , this.selected)

      this.selected = this.removeDuplicates(this.selected, "uuid");


      // this.$vs.loading.close();

    },
    select() {
      this.allSelected = false;
      
      // this.match_ten_context.map(
      //   function(ele) {
      //     if (ele.page == this.currentx) {
      //       return (ele.ten_selected = false);
      //     }
      //   }.bind(this)
      // );
    },
    getCsvFileName(value) {
      this.csv_filename = value;
      // this.table_name = this.csv_filename.replace(/\.[^.$]+$/, '');
    },
    matchField() {
      let self = this
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.PLeasewait = "Please wait while the maching learing is completed. This may take a few minutes."
      this.fieldgroups[0].table_name = this.table_name;
      this.fieldgroups[0].campaign_id = this.$route.params.campaignId;
      this.fieldgroups[0].user_info = userInfo;
      axios
        .post(
          this.$base_url + "/api/contacts/run_machine_learning",
          this.fieldgroups, {
            onDownloadProgress: function( progressEvent ) {

  
              let progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
              
  
              if( progress == 100 ) {
                this.uploadPercentage = 100

                              }
                  
                  
                        }.bind(this),
                        onUploadProgress: function( progressEvent ) {

                  
                          let counts = 0;
                  let interval = setInterval(() => {
                    counts % 3 == 0 ? this.uploadPercentage = counts * 10 : ''
                    counts++;


                    if (counts == 10)
                    clearInterval(interval);
                  },1000);

                  setInterval(5000);


                // if( progress == 100 ) {
                //   this.uploadPercentage = 50

                // }


                }.bind(this)
          })
        .then(response => {

            



          if (response.data.status == "fail") {
            this.validation_message = response.data.message;
          } else {



            if (response.data === undefined || response.data.data.length == 0) {
              // this.finishedEnhanced();
              this.$vs.notify({
                color: "primary",
                title: "Import Contact",
                text:
                  "No record matches has been found. Please upload other files that contains matched contacts."
              });
              self.$router.replace("/contacts/unmatched/" + this.$route.params.campaignId);
              // this.showMatches = false;
              // this.showImportWidget = true;
            } else {
              this.match_contacts = response.data.data;

              console.log("Matched Contacts" , this.match_contacts)
         

              this.showMatches = true;
              this.showMachineLearning = false;
              this.showFieldComparision = false;
              this.showImportWidget = false;
              this.selected = this.removeDuplicates(this.selected, "uuid");
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    finishedEnhanced() {
      let tableData = {};
      tableData.table_name = this.table_name;
      axios
        .post(
          this.$base_url + "/api/contacts/finish_machine_learning_enhance",
          tableData
        )
        .then(response => {
          console.log(error);
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
    created(){
     var self = this
    //  let campaignParam = atob(this.$route.params.campaignId)
    //  this.selected_campaign = JSON.parse(campaignParam)
     this.table_name = 'temp_' + this.$route.params.campaignId.replaceAll("-" , "_") + '_contacts'
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
